//跳转外链-用户端首页
export const web_zc_home = 'https://www.emof.cn'

export const service_phone = '400-999-6541'

export const levels=[
    {value: 0, label: '全部'},
    {value: 1, label: '高'},
    {value: 2, label: '中'},
    {value: 3, label: '低'},
]

export const role_name= (val)=>{
    switch (Number(val)) {
        case 1 :
            return '超管'
        case 2 :
            return '审核人'
        case 3 :
            return '执行人'
    }
}
export const apply_status= (status)=>{
    switch (Number(status)) {
        case 0 : return '待上传通知'
        case 1 : return '通知审核中'
        case -2 : return '通知未通过'
        case 2 : return '待提交申报书'
        case 3 : return '申报书审核中'
        case -4 : return '申报书驳回'
        case 4 : return '申报已通过'
    }
}
export const apply_status_color= (status)=>{
    switch (Number(status)) {
        case 2 :
        case 0 :return 'text-black'
        case 3 :
        case 1 : return 'text-orange'
        case -2 :
        case -4 : return 'text-red'
        case 4 : return 'text-green'
    }
}
export const level_color= (val)=>{
    switch (Number(val)) {
        case 1 :
            return 'danger'
        case 2 :
            return 'success'
        case 3 :
            return 'warning'
    }
}
//1赋分审核中 2赋分审核通过（进行中） 3赋分驳回 4修改任务审核中 5修改任务驳回 6任务评审审核中 7任务完成 8逾期 9任务评审驳回
export const task_color= (val)=>{
    switch (Number(val)) {
        case 0:
        case 1:
        case 4:
        case 6:
            return 'bg-orange'
        case 2 :
            return 'bg-blue light'
        case 7 :
            return 'bg-green'
        case 3 :
        case 5 :
        case 8 :
        case 9 :
            return 'bg-red'
    }
}

export const task_state= (val,is_change)=>{
    switch (Number(val)) {
        case 0 :
            return '未提交'
        case 1 :
            return '赋分审核中'
        case 2 :
            return is_change ? '任务变更' : '进行中'
        case 3 :
            return '已驳回'
        case 4 :
            return `${is_change ? '变更' : '任务'}审核中`
        case 5 :
            return `${is_change ? '变更' : '任务'}被驳回`
        case 6 :
            return '评审审核中'
        case 7 :
            return '已完成'
        case 8 :
            return '已逾期'
        case 9 :
            return '评审被驳回'
    }
}
//是否可以 提交评审
export const is_task_finish =(state)=>{
    return state === 2 || state === 5 || state === 8 || state === 9
}

//是否可以 评审
export const is_task_review =(state)=>{
    return state === 6
}

//是否可以 修改
export const is_task_edit =(state)=>{
    return state === 0 || state === 2 || state === 3 || state === 5 || state === 8 || state === 9
}

export const customColors = [
    {color: '#f56c6c', percentage: 20},
    {color: '#e6a23c', percentage: 40},
    {color: '#5cb87a', percentage: 60},
    {color: '#1989fa', percentage: 80},
    {color: '#6f7ad3', percentage: 100}
]


export const apply_project_menus= [
    {label:'上传通知', value:0},
    {label:'申报项目信息', value:1},
    {label:'申报书撰写', value:2},
    {label:'辅助申报材料撰写', value:3},
]

export const project_status= [
    {label:'未提交审核', value:0},
    {label:'已提交审核', value:1},
    {label:'进行中', value:2},
    {label:'驳回提交', value:3},
]

export const report_node= [
    {label:'每周汇报', value:1},
    {label:'每半月汇报', value:2},
    {label:'每月汇报', value:3},
]

export const add_project_menus= [
    {label:'基本信息', value:0},
    {label:'项目人员', value:1},
    {label:'项目文档', value:2},
    // {label:'发票信息', value:2},
    {label:'任务分配', value:3},
]

export const post_project_menus= [
    {label:'项目结项', value:0},
    {label:'总结记录', value:1},
    {label:'委托方意见', value:2},
    {label:'成果汇总', value:3},
]

export const task_menus= [
    {label:'进行中', value:2},
    {label:'已驳回', value:9},
    {label:'已逾期', value:8},
    {label:'已完成', value:7},
]

export const units_menus= [
    {label:'委托单位', value:1},
    {label:'承办单位', value:2},
]

export const menus = [
    { value: 0, role: [1,2,3], label: '首页', icon: 'icon-shouye', page: '/web/staff/index',child:[]},
    { value: 1, role: [1,2,3], label: '项目管理', icon: 'icon-xiangmu2', page: '/web/staff/apply/list',child:[
       { value: 6, role: [1,2,3], label: '项目申报', icon: 'icon-xiangmushenbao', page: '/web/staff/apply/list' },
       { value: 0, role: [1,2,3], label: '项目列表', icon: 'icon-xiangmu', page: '/web/staff/project/list' },
       { value: 3, role: [1,2], label: '项目审核', icon: 'icon-fapiaoshenhe', page: '/web/staff/project/apply' },
       { value: 9, role: [1], label: '项目类别管理', icon: 'icon-classify', page: '/web/admin/project/classify' },
       { value: 7, role: [1,2,3], label: '项目成果汇总', icon: 'icon-jishuchengguo', page: '/web/staff/outcome/list' },
    ]},
    { value: 2, role: [1,2,3], label: '任务管理', icon: 'icon-renwu1', page: '/web/staff/task/mine',child:[
       { value: 1, role: [1,2,3], label: '我的任务', icon: 'icon-renwu', page: '/web/staff/task/mine' },
    ]},
    { value: 3, role: [1], label: '人员管理', icon: 'icon-renyuan', page: '/web/admin/verifier',child:[
       { value: 2, role: [1], label: '审核人员列表', icon: 'icon-shenhe', page: '/web/admin/verifier' },
    ]},
    { value: 4, role: [1], label: '单位管理', icon: 'icon-danwei', page: '/web/admin/units',child:[
       // { value: 4, role: [1], label: '单位管理', icon: 'icon-zuoyedanwei', page: '/web/staff/apply/list' },
    ]},
    { value: 6, role: [1], label: '数据统计', icon: 'icon-tongji1', page: '/web/admin/statistics',child:[
       // { value: 10, role: [1], label: '数据统计', icon: 'icon-tongji', page: '/web/admin/statistics' },
    ]},
    { value: 9, role: [1,2,3], label: '意见反馈', icon: 'icon-bangzhuzhongxin', page: '/web/staff/feedback',
        child:[]
    },
    // { value: 8, role: [1,2,3], label: '帮助中心', icon: 'icon-kefu', page: '/web/help' },
]


export const FILE_ACCEPT = {
    IMAGE: 'image/*',//图片
    VIDEO: 'video/*,audio/*',//音视频
    WORD: 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-works',//word
    EXPM_WORD: '.docx',//word
    EXCEL: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-works',//excel
    PPT: 'application/vnd.ms-powerpoint,application/vnd.ms-works',//ppt
    PDF: 'application/pdf',//pdf
    ZIP: '.zip,application/zip,application/x-compressed',//zip
    RAR: '.rar',//rar
}
